<template>
  <v-app>
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar"
      timeout="800" :value="true" color="warning" absolute outlined top right>
      <v-icon class="mr-2" color="warning">mdi-alert-outline</v-icon>
      {{ errMsg }}
      <v-icon @click="snackbar = false" class="float-right" color="warning">mdi-close-circle</v-icon>

    </v-snackbar>
    <v-container class="pa-0 pa-sm-3 pa-md-3">
      <div class="px-sm-4">
        <v-toolbar dense class="elevation-0 mb-4 mt-6 pr-4">
          <v-toolbar-title>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold headline">Clients</v-list-item-title>
                <v-list-item-subtitle class="body-1 mb-0 mt-1" color="#878B93">
                  Clients status and trade segments here.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-badge v-if="modeis != 'r'" :value="filrevenuedata.length" bordered overlap color="#3B82F6" :content="filrevenuedata.length">
            <v-select :disabled="clientLoader" color="#3B82F6" @change="clientFilter" style="max-width: 160px" outlined
              class="mt-2 rounded-lg" dense :items="['All', 'AP', 'RM', 'Direct']" label="Clients" v-model="clientstype"
              hide-details></v-select>
          </v-badge>
          <div v-if="modeis != 'r'" class="ml-4">
            <v-text-field :disabled="clientLoader" color="#3B82F6" v-if="clientstype == 'All'" outlined dense
              class="mr-4 rounded-lg mt-9 d-none d-md-flex" style="max-width: 160px" label="Search" v-model="searchText"
              prepend-inner-icon="mdi-magnify">
            </v-text-field>
            <v-text-field :disabled="clientLoader" color="#3B82F6" v-else-if="clientstype == 'Direct'"
              class="mr-4 mt-9 rounded-lg d-none d-md-flex" style="max-width: 160px" dense outlined flat label="Search"
              v-model="searchText" prepend-inner-icon="mdi-magnify">
            </v-text-field>
            <v-autocomplete :disabled="clientLoader" color="#3B82F6" v-else @change="clisFilter" style="max-width: 160px"
              outlined class="mr-4 mt-2 rounded-lg" dense :items="clisitems" label="AP/RM filter" v-model="clisimodel"
              hide-details></v-autocomplete>
          </div>
          <v-text-field  v-if="modeis == 'r'" :disabled="clientLoader" color="#3B82F6" outlined dense
              class="mr-4 rounded-lg mt-9 d-none d-md-flex" style="max-width: 160px" label="Search" v-model="searchText"
              prepend-inner-icon="mdi-magnify">
            </v-text-field>

          <div>
            <v-tooltip open-delay="400" color="black" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-card v-bind="attrs" v-on="on" :color="`${daytabval == 'current_month' ? '#EFF6FF' : ''}`"
                  :disabled="clientLoader" @click="daytableFilter((val = 'current_month'))" width="40px" outlined
                  class="mt-2 py-2 elevation-0 rounded-l-lg rounded-0 text-center">
                  <span :style="`color:${daytabval == 'current_month' ? '#3B82F6' : 'black'
                    };`" class="caption">CM</span>
                </v-card>
              </template>
              <span>Current month</span>
            </v-tooltip>
          </div>
          <div>
            <v-tooltip open-delay="400" color="black" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-card v-bind="attrs" v-on="on" :color="`${daytabval == 'last_month' ? '#EFF6FF' : ''}`"
                  :disabled="clientLoader" @click="daytableFilter((val = 'last_month'))" width="40px" outlined
                  class="mt-2 py-2 elevation-0 rounded-0 text-center">
                  <span :style="`color:${daytabval == 'last_month' ? '#3B82F6' : 'black'
                    };`" class="caption">LM</span>
                </v-card>
              </template>
              <span>Last month</span>
            </v-tooltip>
          </div>
          <v-card :color="`${daytabval == 'three_months' ? '#EFF6FF' : ''}`" :disabled="clientLoader"
            @click="daytableFilter((val = 'three_months'))" width="40px" outlined
            class="mt-2 py-2 elevation-0 rounded-0 text-center">
            <span :style="`color:${daytabval == 'three_months' ? '#3B82F6' : 'black'
              };`" class="caption">3M</span>
          </v-card>
          <v-card :color="`${daytabval == 'six_months' ? '#EFF6FF' : ''}`" @click="daytableFilter((val = 'six_months'))"
            :disabled="clientLoader" width="40px" outlined class="mt-2 py-2 elevation-0 rounded-0 text-center">
            <span :style="`color:${daytabval == 'six_months' ? '#3B82F6' : 'black'};`" class="caption">6M</span>
          </v-card>
          <v-card :color="`${daytabval == 'one_year' ? '#EFF6FF' : ''}`" @click="daytableFilter((val = 'one_year'))"
            :disabled="clientLoader" width="40px" outlined class="mt-2 py-2 elevation-0 rounded-0 text-center">
            <span :style="`color:${daytabval == 'one_year' ? '#3B82F6' : 'black'};`" class="caption">1Y</span>
          </v-card>
          <v-menu v-model="menu22" :close-on-content-click="false" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-card v-bind="attrs" v-on="on" :color="`${daytabval == 'custom' ? '#EFF6FF' : ''}`"
                :disabled="clientLoader" width="48px" outlined
                class="mt-2 py-2 elevation-0 rounded-r-lg rounded-0 text-center">
                <span :style="`color:${daytabval == 'custom' ? '#3B82F6' : 'black'
                  };`" class="caption">CUST</span>
              </v-card>
            </template>
            <v-card width="580px">
              <v-row no-gutters>
                <v-col cols="6">
                  <v-date-picker v-model="dateSelect2" :max="maxDate2"></v-date-picker>
                </v-col>
                <v-col cols="6">
                  <v-date-picker v-model="dateSelectto" :min="dateSelect2" :max="maxDate2"
                    @input="(menu22 = false), (menu2to = false), dayCustom()"></v-date-picker>
                </v-col>
              </v-row>
            </v-card>
          </v-menu>
        </v-toolbar>

        <div class="px-4 pt-2">

          <div class="pt-2">
            <v-data-table dense fixed-header class="dataTable" height="51vh" :sort-by="['FIRST_REG_DATE']"
              style="border: 1px solid rgba(0, 0, 0, 0.12)" sort-desc must-sort :items-per-page="100" :footer-props="{
                'items-per-page-options': [10, 30, 50, 100, -1],
              }" :loading="clientLoader" :headers="headers" :items="filrevenuedata" :search="searchText">
              <template v-slot:[`item.BRANCHACTIVE`]="{ item }">
                <div style="color: #f43f5e" v-if="item.BRANCHACTIVE == 'I'">
                  Inactive
                </div>
                <div style="color: #12b2a1" v-if="item.BRANCHACTIVE == 'A'">
                  Active
                </div>
              </template>
              <template v-slot:[`item.SEGMENTS`]="{ item }">
                <div class="d-inline-flex" v-for="(x, n) in item.SEGMENTS" :key="x.Exch">
                  <v-chip :class="n == item.SEGMENTS.length - 1 ? 'mr-2' : ''" x-small
                    :color="x.Active_inactive == 'A' ? '#F0FDFA' : '#FEF2F2'"
                    :text-color="x.Active_inactive == 'A' ? '#12B2A1' : '#F43F5E'">
                    <span> {{ x.Exch }}</span>
                  </v-chip>
                </div>
              </template>
              <template v-slot:[`item.FIRST_REG_DATE`]="{ item }">
                <span>{{ item.FIRST_REG_DATE.slice(0, 10) }}</span>
              </template>
              <template v-slot:[`item.CLIENT_ID`]="{ item }">
                <span>{{ item.CLIENT_ID }}
                  <v-chip x-small color="#EFF6FF" text-color="#3B82F6"
                    v-if="item.REM_CODE != '' ? item.REM_CODE : item.RELATIONMANAGER_CODE != '' ? item.RELATIONMANAGER_CODE : ''">
                    {{ item.REM_CODE != '' ? item.REM_CODE : item.RELATIONMANAGER_CODE != '' ?
                      item.RELATIONMANAGER_CODE : ''
                    }}
                  </v-chip>
                </span>
              </template>
            </v-data-table>

          </div>
        </div>
      </div>
    </v-container>
  </v-app>
</template>
  
<script>
import { apiurl } from "../apiUrl";
import axios from "axios";

export default {
  data() {
    return {
      snackbar: false,
      clientData: [],
      filrevenuedata: [],
      errMsg: "",
      clientLoader: true,
      searchText: "",
      branchcode: null,

      menu2: false,
      menu22: false,
      menu2to: false,

      dateSelect: new Date().toISOString().substr(0, 7),
      maxDate: new Date().toISOString().substr(0, 7),

      dateSelectto: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      dateSelect2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      maxDate2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      daytabval: "current_month",
      date: new Date().toISOString().substr(0, 7),
      clientstype: 'All',
      clisimodel: 'All',
      clisitems: [],
      modeis: null
    };
  },
  created() {
    let modeis = localStorage.getItem('mode');
    if (modeis == 'RM') {
      this.modeis = 'r';
      this.clientstype = 'RM';
    } else {
      this.modeis = 'b';
      this.clientstype = 'All';
    }

    this.branchcode = localStorage.getItem('brcode')
  },

  mounted() {
    this.getAllClientData();
    // this.clientDetails();
    // this.analyseData();
    // this.getClifilterdata();
    // this.lastTradecounr();
    //   this.getcalendar()
  },

  methods: {
    getAllClientData() {
      this.clientLoader = true;
      this.clientData = [];
      this.filrevenuedata = [];
      let data;
      if (this.daytabval == 'custom') {
        data = JSON.stringify({
          "branch_code": this.branchcode,
          "values": this.daytabval,
          "start_date": this.dateSelect2,
          "end_date": this.dateSelectto
        });
      } else {
        data = JSON.stringify({
          "branch_code": this.branchcode,
          "values": this.daytabval,
          "start_date": '',
          "end_date": ''
        });
      }

      let config = {
        method: 'post',
        url: `${apiurl}/getClientData`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      let axiosThis = this;
      axios.request(config)
        .then((response) => {
          if (response.data) {
            axiosThis.clientData = response.data;
            axiosThis.clientLoader = false;
            axiosThis.clientFilter();
            // let clientdata = response.data;
            // let rm = []
            // let ap = []
            // let dc = []
            // let o = []

            // for (let e = 0; e < clientdata.length; e++) {
            //   if (clientdata[e].REM_CODE != null) {
            //     ap.push(clientdata[e])
            //   } else if (clientdata[e].RELATIONMANAGER_CODE != null && clientdata[e].REM_CODE == null) {
            //     rm.push(clientdata[e])
            //   } else if (clientdata[e].REM_CODE == null && (clientdata[e].RELATIONMANAGER_CODE == null)) {
            //     dc.push(clientdata[e])
            //   } else {
            //     o.push(clientdata[e])
            //   }
            // }
            // console.log("ap", ap,"rm", rm,"dc", dc, "o", o);
          }
        })
        .catch((error) => {
          console.log(error);
        });

    },
    clientFilter() {
      this.clientLoader = true;
      this.filrevenuedata = [];
      let modeis = localStorage.getItem('mode');

      if (this.clientstype == 'All' || modeis == 'RM') {
        this.filrevenuedata = this.clientData;
      } else {
        this.clisitems = [];
        this.clisitems = ['All'];
        this.clisimodel = 'All'
        for (let e = 0; e < this.clientData.length; e++) {
          if (this.clientstype == 'AP' && this.clientData[e].REM_CODE != "") {
            this.clientData[e]['codeis'] = this.clientData[e].REM_CODE;
            this.filrevenuedata.push(this.clientData[e])
          } else if (this.clientstype == 'RM' && this.clientData[e].RELATIONMANAGER_CODE != "" && this.clientData[e].REM_CODE == "") {
            this.clientData[e]['codeis'] = this.clientData[e].RELATIONMANAGER_CODE;
            this.filrevenuedata.push(this.clientData[e])
          } else if (this.clientstype == 'Direct' && this.clientData[e].REM_CODE == "" && this.clientData[e].RELATIONMANAGER_CODE == "") {
            this.filrevenuedata.push(this.clientData[e])
          }
        }
        let clis = this.getUniqueListBy(this.filrevenuedata, 'codeis')
        for (let f = 0; f < clis.length; f++) {
          this.clisitems.push(clis[f].codeis);
        }
        this.clisitems.sort();
      }
      this.clientLoader = false;
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()]
    },
    clisFilter() {
      this.clientLoader = true;
      let modeis = localStorage.getItem('mode');

      if (this.clisimodel == 'All' || modeis == 'RM') {
        this.clientFilter();
      } else {
        this.filrevenuedata = [];
        for (let o = 0; o < this.clientData.length; o++) {
          if (this.clientData[o].codeis == this.clisimodel) {
            this.filrevenuedata.push(this.clientData[o])
          }
        }
        // console.log(" this.filrevenuedata", this.filrevenuedata);
      }
      this.clientLoader = false;
    },

    daytableFilter(val) {
      if (val != this.daytabval) {
        this.clientLoader = true;
        this.daytabval = val;
        this.getAllClientData();
      }
    },

    dayCustom() {
      this.clientLoader = true;
      this.daytabval = 'custom';
      this.getAllClientData();
    },

  },

  computed: {
    headers() {
      return [
        { text: "Client ID", value: "CLIENT_ID", sortable: false },
        { text: "Client Name", value: "CLIENT_NAME", width: '20%' },
        { text: "Status", value: "BRANCHACTIVE", sortable: false },
        // { text: "Exchange", value: "SEGMENTS", sortable: false, width: '30%' },
        { text: "Reg date", value: "FIRST_REG_DATE" },
        { text: "First traded date", value: "FIRST_TRADED_DATE" },
        { text: "Last traded date", value: "LAST_TRADED_DATE" },
      ];
    },
  },
};
</script>
  
<style>
.colums {
  position: static;
  float: left;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.dataTable {
  overflow-y: scroll;
}

.dataTable thead.v-data-table-header {
  position: relative;
  z-index: 1 !important;
}

/* .headline { */
/* font-family: 'DM Sans' !important; */
/* font-weight: 500; */
/* } */
.trdditl::-webkit-scrollbar {
  width: 6px;
}

.trdditl::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.trdditl::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.6);
  border-radius: 16px;
}

.toolbar .v-toolbar__content {
  padding: 0 !important;
}

.datedetailshead .v-data-table-header__sort-badge {
  display: none !important;
}
</style>
<style lang="scss">
.colums {
  position: static;
  float: left;
}

.v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 0 !important;
}
</style>
  